<template>
<DashBoardLayout :showNavbar=false :isSearch=false >
    <div class="col-lg-11 col-11 auto">	
		<div class="row order-summary w100 center mt-5">
           <p class="w100"> <img src="../../assets/images/Order-Placed-Successfully.png" class="center"/></p>
			<div class="center auto w100">
                <h2><i class="fas fa-shipping-fast"></i> Order Placed Successfully! Thank you</h2>
            </div>
            <p class="w100">Your order number is #{{ $route.params.id }}.</p>
			<div class="center w100">
                 <router-link to='/home' class="primary-btn-kr-outline mb-5">Continue Shopping</router-link><br>
                  <button @click="viewOrders()">View Orders</button>	
            </div>
        </div>
    </div>
</DashBoardLayout>
</template>

<script>
import DashBoardLayout from '../../layouts/DashboardLayout.vue'
export default {
    name: 'Thanku',
    components: {
        DashBoardLayout
    },
    // created(){
    //     this.$emit(`update:layout`,DashBoardLayout)
    // },
    // data() {
    //     return {
    //         orderId: '',
    //     }
    // },
    // methods: {
    //     viewOrders:function(){
    //         this.$router.push('/orders');
    //     }
    // },
}
</script>
